import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "@/services/auth";

export async function PostAdminQuestionnaireResponse(
  dataObj: any,
  authType?: string
) {
  let url = `${endpoints.ADMFHIR}/QuestionnaireResponse`;

  const data = dataObj;
  const headers = {
    Accept: "application/fhir+json",
    Authorization:
      authType === "application"
        ? await OAuthApplication()
        : await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 8000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostAdminQuestionnaireResponse: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostAdminQuestionnaireResponse ", error);
      // toast.error(
      //   `PostAdminQuestionnaireResponse Error: ${error?.response?.status}`
      // );
      throw new Error();
    });
  if (response) return response;
}
